export default __webpack_public_path__ + "01f989e2bc00cd0888ac7bcfa690c470.png";